import * as React from 'react';
import Tooltip from "./Tooltip";
import { getText } from '../utils/langTexts';
import * as Api from '../api/api';
import { Warning } from '@material-ui/icons';
import * as Colors from '../styles/colors';
import Collapsible from 'react-collapsible';
import { Accordion } from '@material-ui/core';
import ExpansionPanel from './ExpansionPanel';

interface RatesFetcherResultProps {
    subscriptions: Array<Api.SubscriptionModel>;
    carrierRatesStates: { [key: string]: { isLoading: boolean; carrierRatesPlatformId: number; errors: Array<Api.RatesFetcherErrorModel> } };
}



interface RatesFetcherResultOwnProperties {
    isOpen: boolean;

}


export default class RatesFetcherResult extends React.Component<RatesFetcherResultProps, RatesFetcherResultOwnProperties> {



    constructor(props: RatesFetcherResultProps) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

   

    changeOpened() {
   
        this.setState((prevState) => ({
            isOpen: !prevState.isOpen,
        }));
    }

    replaceHereWithLink(text: string, linkHref: string): React.ReactNode {
        const parts = text.split('{here}');
    
        return parts.map((part, index) => (
            <span key={index}>
                {part}
                {index < parts.length - 1 && (
                    <a href={linkHref} style={{ textDecoration: "underline", cursor: "pointer" }}>
                        here
                    </a>
                )}
            </span>
        ));
    }



    public render() {
        let listOfErrors = Object.values(this.props.carrierRatesStates)
            .filter(x => !x.isLoading)
            .map(v => v.errors)
            .reduce((acc, errors) => acc.concat(errors), []);
        
        let loginIssues = listOfErrors.filter(e => e.type == 'WrongCredentials');
        let accesIsues = listOfErrors.filter(e => e.type == 'NoRightsForAccess' || e.type == 'Mfa' || e.type == 'MfaSystem'
            || e.type == 'NoRightsForAccessScopeCma' || e.type == 'AccountExpired');
        let noConnection = listOfErrors.filter(e => e.type == 'NoConnection' || e.type == 'AuthenticationError' || e.type == 'Exception');
        let noResults = listOfErrors.filter(e =>
            e.type == 'EmptyResults'
            || e.type == 'UnsuportedRoute'
            || e.type == 'UnsuportedContainer'
            || e.type == 'Unsuported'

        );
        let isLoading = Object.values(this.props.carrierRatesStates).some(x => x.isLoading);
        let allIsOk = Object.values(this.props.carrierRatesStates).every(x => !x.isLoading && x.errors.length == 0);
        let allOtherIsOk = Object.values(this.props.carrierRatesStates).some(x => !x.isLoading && x.errors.length == 0);

        let coveredTypes = ['WrongCredentials', 'NoConnection', 'AuthenticationError',
            'EmptyResults', 'NoRightsForAccess', 'MfaSystem', 'Mfa', 'Unknown', 'Unsuported', 'UnsuportedContainer', 'UnsuportedRoute', "Exception", "NoRightsForAccessScopeCma", "AccountExpired"];

        noConnection = noConnection.concat(listOfErrors.filter(e => !coveredTypes.includes(e.type)));

        let hasIssues = noConnection.concat(loginIssues).concat(accesIsues);
        //console.log(hasIssues, "hasIssues");
        //console.log(allIsOk,"allIsOk");
        //console.log(noConnection,"no conenection");

        //console.log(noResults, "noresults");
        return (
            <div>
                <div>
                    {isLoading && <span>Some connection results are already available. Click <a style={{ textDecoration: "underline", fontWeight:'bold', cursor: "pointer" }} onClick={(e) => this.changeOpened()}>here</a> to view details.</span>}
                    {!isLoading && (noResults.length > 0 && hasIssues.length>0) && <span>Some connections encountered issues or have no available offers. Click <a style={{ textDecoration: "underline", fontWeight:'bold', cursor: "pointer" }} onClick={(e) => this.changeOpened()}>here</a> to view details.</span>}
                    {!isLoading && (!allIsOk && hasIssues.length > 0 && noResults.length == 0) && <span> Some connections encountered issues. Click <a style={{ textDecoration: "underline", fontWeight: 'bold', cursor: "pointer" }} onClick={(e) =>this.changeOpened()}>here</a> to view details.</span>}
                    {!isLoading && (!allIsOk && noResults.length == listOfErrors.length) && <span>Some connections have no available offers. Click <a style={{ textDecoration: "underline", fontWeight: 'bold', cursor: "pointer" }} onClick={(e) => this.changeOpened()}>here</a> to view details.</span>}
                    {!isLoading && allIsOk && <span> All connections have been correctly loaded.</span>}
                </div>
                <ExpansionPanel expanded={this.state.isOpen}
                    onChange={(v) => { }}
                    head={<span></span>}
                    style={{ border: "1px" }}
                >
                    <div style={{ display: "flex", flexDirection: "column", borderRadius: 10, borderWidth: 0.5, borderStyle:"solid", padding:"10px" }}>
                        <div >
                            <a style={{  float: "right", cursor:"pointer" }} onClick={(e) => this.changeOpened()}>X</a>
                        </div>   
                        {loginIssues.length > 0 &&
                            <div style={{ flex: "0 0 auto", padding: "0px 6px" }}>
                                <b>🔑 Login Issues</b>
                                {loginIssues.map((message) => (<div style={{ paddingLeft: "22px", color:"#a91111" }} >
                                    <div></div>{this.replaceHereWithLink(message.message, "carrierRatesSettings")  }                                  
                                </div>))}
                            </div>
                        }
                        {accesIsues.length > 0 &&
                            <div style={{ flex: "0 0 auto", padding: "0px 6px" }}>
                                <b>🔒 Access Issues</b>
                                {accesIsues.map((message) => (<div style={{ paddingLeft: "22px", color: "#a91111" }} >{message.message}</div>))}
                            </div>
                        }
                        {noConnection.length > 0 &&
                            <div style={{ flex: "0 0 auto", padding: "0px 6px" }}>
                                <b>⛓️‍💥 Connection Issues</b>
                                {noConnection.map((message) => (<div style={{ paddingLeft: "22px" }} >{message.message}</div>))}

                            </div>
                        }
                        {noResults.length > 0 &&
                            <div style={{ flex: "0 0 auto", padding: "0px 6px" }}>
                                <b>📭 No Available Offers</b>
                                {noResults.map((message) => (<div style={{ paddingLeft: "22px" }} >{message.message}</div>))}
                            </div>
                        }
                        {allOtherIsOk &&
                            <div style={{ flex: "0 0 auto", padding: "0px 6px" }}>
                                <b>✅ System Status</b>
                                <div style={{ paddingLeft: "22px" }} >All other connections have been correctly loaded.</div>

                            </div>
                        }
                    </div>
                </ExpansionPanel>

            </div>
        );
    }
}

